import { PlatformType } from '@/types';

export const detectMobile = (): boolean => {
  if (typeof window === 'undefined') return false;

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|windows phone|mobile|tablet/i.test(userAgent);
};

export const getPlatformType = (): PlatformType => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(userAgent)) return 'ios';
  if (/android/.test(userAgent)) return 'android';
  if (/windows|macintosh|linux/.test(userAgent) &&
    !/mobile|android|iphone|ipad|ipod/.test(userAgent)) return 'web';

  return 'others';
};

export const getEventScreenUrl = (): string => {
  if (typeof window !== 'undefined' && window.document) {
    return window.location.href;
  }
  return '';
};
